module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// ./~/ramdasauce/~/ramda/src/internal/_identity.js
// module id = 145
// module chunks = 0